<template>
  <div class="L1">
    <div class="L1_title">
      <div class="default_title">
        <div :style="[{maskImage: `url(${route.icon1})`}, route.iconSize?{maskSize: route.iconSize}:{}]"></div>
        <div>{{label}}</div>
      </div>
      <div class="slot_title">
        <slot name="slot_title"/>
      </div>
    </div>
    <div class="L1_body">
      <slot/>
    </div>
    <div class="popup" ref="popup" v-if="popup">
      <slot name="popup"/>
    </div>
  </div>
</template>

<script>
export default {
  props: ['popup', 'label'],
  data () {
    return {
      toggle: (screen.orientation.angle === 0)
    }
  },
  computed: {
    route () {
      return this.$route.meta
    }
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
.L1 {
  z-index: 10;
  min-height: 100vh;
  max-height: 100vh;
  display: grid;
  width: 100%;
  padding: 0;
  background-color: #FFFFFF;
  .L1_title {
    height: 89px;
    border-bottom: 1px solid var(--color-fn9);
    z-index: 10;
    flex:1;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #FFFFFF;
    padding-inline: 23px 32px;
    width: 100%;
    gap: 8px;
    margin: 0;
  }
  .L1_body {
    z-index: 9;
    flex:1;
    width: 100%;
    height: calc(100vh - 89px);
    overflow-y: auto;
  }
}
  .L1 {
    grid-template-rows: 89px calc(100vh - 89px);
    z-index: 10;
    min-height: 100vh;
    max-height: 100vh;
    display: grid;
    width: 100%;
    background-color: #FFFFFF;
  }
  .default_title {
    min-width: fit-content;
  }
  .L1_title {
    &>div:nth-child(1) {
      height: 32px;
      display: flex;
      align-items: center;
      gap: 10px;
      z-index: 9;

      &>div:nth-child(1) {
        width: 55px;
        height: 46px;
        background-color: var(--color-pri);
        mask-position: center center;
        mask-size: 40px;
        mask-repeat: no-repeat;
      }
      &>div:nth-child(2) {
        color:  var(--color-pri);
        font-size: 32px;
        font-weight: 400;
        letter-spacing: .1em;
      }
    }
    .slot_title {
      display: flex;
      margin: 0;
      margin-left: 28px;
      gap: 23px;
      height: 89px;
      width: -webkit-fill-available;
      align-items: center;
    }
  }
  .popup {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--backdrop);
    backdrop-filter: blur(5px);
    z-index: 200;
  }
</style>
